// Returns meta data for the Browse page
export const BrowsePageMetaService_GetMetaDataLazy = () =>
  import("./service.grpc").then((m) => m.BrowsePageMetaService_GetMetaData);
BrowsePageMetaService_GetMetaDataLazy.method =
  "aysa_api.services.browse_page.v1.meta.BrowsePageMetaService/GetMetaData" as const;
